module.exports = __webpack_public_path__ + "img/vietnam.a53d5e7b.svg";